import React, { Component } from "react";
import {
	DECLARACION_JURADAS,
	DECLARACION_JURADAS_NEW,
	DECLARACION_JURADAS_SHOW,
	AFILIADOS,
	AFILIADOS_NEW,
	AFILIADOS_EDIT,
	BOLETAS,
	BOLETAS_NEW,
	BOLETAS_REGENERATE,
	EMPRESAS,
	EMPRESAS_NEW,
	EMPRESAS_EDIT,
	INDEX,
	PASSWORD_RECOVERY,
	CONFIRMPASSWORD,
	RESEND_EMAIL_CONFIRM,
	FIXED_CONTRIBUTIONS,
	FIXED_CONTRIBUTIONS_NEW,
	FIXED_CONTRIBUTIONS_EDIT,
	HOLIDAYS,
	HOLIDAYS_NEW,
	HOLIDAYS_EDIT,
	BI_COMPANY,
	BI_AFFILIATE,
	BI_PROVINCE,
	USER_CONTROL,
	USER_CONTROL_NEW,
	USER_CONTROL_EDIT
} from "../../config/RoutesConstants";
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";

class Breadcrumb extends Component {
	renderPathname() {
		let concatenatedRoutes = [];
		const routeStyle = { textDecoration: "none", color: "#9A9DA2" };

		switch (this.props.pathname) {
			case HOLIDAYS:
				concatenatedRoutes.push({
					render: (
						<Link to={HOLIDAYS} style={routeStyle}>
							Feriados
						</Link>
					),
					id: HOLIDAYS
				});
				break;
			case HOLIDAYS_NEW:
				concatenatedRoutes.push({
					render: (
						<Link to={HOLIDAYS_NEW} style={routeStyle}>
							Nuevo Feriado
						</Link>
					),
					id: HOLIDAYS_NEW
				});
				break;
			case HOLIDAYS_EDIT:
				concatenatedRoutes.push({
					render: (
						<Link to={HOLIDAYS_EDIT} style={routeStyle}>
							Editar/Ver Feriados
						</Link>
					),
					id: HOLIDAYS_EDIT
				});
				break;
			case FIXED_CONTRIBUTIONS:
				concatenatedRoutes.push({
					render: (
						<Link to={FIXED_CONTRIBUTIONS} style={routeStyle}>
							Contribuciones Fijas
						</Link>
					),
					id: FIXED_CONTRIBUTIONS
				});
				break;
			case FIXED_CONTRIBUTIONS_NEW:
				concatenatedRoutes.push({
					render: (
						<Link to={FIXED_CONTRIBUTIONS_NEW} style={routeStyle}>
							Nueva Contribución Fija
						</Link>
					),
					id: FIXED_CONTRIBUTIONS_NEW
				});
				break;
			case FIXED_CONTRIBUTIONS_EDIT:
				concatenatedRoutes.push({
					render: (
						<Link to={FIXED_CONTRIBUTIONS_EDIT} style={routeStyle}>
							Editar/Ver Contribución Fija
						</Link>
					),
					id: FIXED_CONTRIBUTIONS_EDIT
				});
				break;
			case USER_CONTROL:
				concatenatedRoutes.push({
					render: (
						<Link to={USER_CONTROL} style={routeStyle}>
							Usuarios
						</Link>
					),
					id: USER_CONTROL
				});
				break;
			case USER_CONTROL_NEW:
				concatenatedRoutes.push({
					render: (
						<Link to={USER_CONTROL_NEW} style={routeStyle}>
							Nuevo Usuario
						</Link>
					),
					id: USER_CONTROL_NEW
				});
				break;
			case USER_CONTROL_EDIT:
				concatenatedRoutes.push({
					render: (
						<Link to={USER_CONTROL_EDIT} style={routeStyle}>
							Editar/Ver Usuarios
						</Link>
					),
					id: USER_CONTROL_EDIT
				});
				break;
			case DECLARACION_JURADAS:
				concatenatedRoutes.push({
					render: (
						<Link to={DECLARACION_JURADAS} style={routeStyle}>
							Declaraciones Juradas
						</Link>
					),
					id: DECLARACION_JURADAS
				});
				break;
			case DECLARACION_JURADAS_NEW:
				concatenatedRoutes.push({
					render: (
						<Link to={DECLARACION_JURADAS_NEW} style={routeStyle}>
							Nueva Declaracion Jurada
						</Link>
					),
					id: DECLARACION_JURADAS_NEW
				});
				break;
			case DECLARACION_JURADAS_SHOW:
				concatenatedRoutes.push({
					render: (
						<Link to={DECLARACION_JURADAS_SHOW} style={routeStyle}>
							Ver Declaración Jurada
						</Link>
					),
					id: DECLARACION_JURADAS_SHOW
				});
				break;
			case AFILIADOS:
				concatenatedRoutes.push({
					render: (
						<Link to={AFILIADOS} style={routeStyle}>
							Afiliados
						</Link>
					),
					id: AFILIADOS
				});
				break;
			case AFILIADOS_EDIT:
				concatenatedRoutes.push({
					render: (
						<Link to={AFILIADOS_EDIT} style={routeStyle}>
							Editar Afiliados
						</Link>
					),
					id: AFILIADOS_EDIT
				});
				break;
			case AFILIADOS_NEW:
				concatenatedRoutes.push({
					render: (
						<Link to={AFILIADOS_NEW} style={routeStyle}>
							Nuevo Afiliados
						</Link>
					),
					id: AFILIADOS_NEW
				});
				break;

			case BOLETAS:
				concatenatedRoutes.push({
					render: (
						<Link to={BOLETAS} style={routeStyle}>
							Boletas
						</Link>
					),
					id: BOLETAS
				});
				break;
			case BOLETAS_REGENERATE:
				concatenatedRoutes.push({
					render: (
						<Link to={BOLETAS_REGENERATE} style={routeStyle}>
							Generar nueva boleta
						</Link>
					),
					id: BOLETAS_REGENERATE
				});
				break;
			case BOLETAS_NEW:
				concatenatedRoutes.push({
					render: (
						<Link to={BOLETAS_NEW} style={routeStyle}>
							Nuevo Boletas
						</Link>
					),
					id: BOLETAS_NEW
				});
				break;

			case EMPRESAS:
				concatenatedRoutes.push({
					render: (
						<Link to={EMPRESAS} style={routeStyle}>
							Empresas
						</Link>
					),
					id: EMPRESAS
				});
				break;
			case EMPRESAS_EDIT:
				concatenatedRoutes.push({
					render: (
						<Link to={EMPRESAS_EDIT} style={routeStyle}>
							Editar Empresas
						</Link>
					),
					id: EMPRESAS_EDIT
				});
				break;
			case EMPRESAS_NEW:
				concatenatedRoutes.push({
					render: (
						<Link to={EMPRESAS_NEW} style={routeStyle}>
							Alta Empresa
						</Link>
					),
					id: EMPRESAS_NEW
				});
				break;
			case RESEND_EMAIL_CONFIRM:
				concatenatedRoutes.push({
					render: (
						<Link to={RESEND_EMAIL_CONFIRM} style={routeStyle}>
							Reenviar mail de confirmación
						</Link>
					),
					id: RESEND_EMAIL_CONFIRM
				});
				break;
			case CONFIRMPASSWORD:
				concatenatedRoutes.push({
					render: (
						<Link to={CONFIRMPASSWORD} style={routeStyle}>
							Cambiar Contraseña
						</Link>
					),
					id: CONFIRMPASSWORD
				});
				break;
			case PASSWORD_RECOVERY:
				concatenatedRoutes.push({
					render: (
						<Link to={PASSWORD_RECOVERY} style={routeStyle}>
							Restablecer Contraseña
						</Link>
					),
					id: PASSWORD_RECOVERY
				});
				break;
			case BI_COMPANY:
				concatenatedRoutes.push({
					render: (
						<Link to={BI_COMPANY} style={routeStyle}>
							Business Intelligence - Empresas
						</Link>
					),
					id: BI_COMPANY
				});
				break;
			case BI_PROVINCE:
				concatenatedRoutes.push({
					render: (
						<Link to={BI_PROVINCE} style={routeStyle}>
							Business Intelligence - Provincias
						</Link>
					),
					id: BI_PROVINCE
				});
				break;
			case BI_AFFILIATE:
				concatenatedRoutes.push({
					render: (
						<Link to={BI_AFFILIATE} style={routeStyle}>
							Business Intelligence - Afiliados
						</Link>
					),
					id: BI_AFFILIATE
				});
				break;
			default:
				concatenatedRoutes.push({
					render: <div />,
					id: 0
				});
		}
		return concatenatedRoutes[0].render;
	}
	render() {
		return (
			<div className="breadcrumb-container" style={{}}>
				<Link to={INDEX} className="breadcrumb-link" style={{}}>
					UPSRA
				</Link>
				<span style={{ color: "#2d5986" }}> › </span>
				{this.renderPathname()}
			</div>
		);
	}
}

export default withRouter(Breadcrumb);



// WEBPACK FOOTER //
// ./src/components/Breadcrumb/Breadcrumb.js